const actionScope = '[Log In With Third Party Sso]';

export class LogInWithThirdPartySso {
  static readonly type = `${actionScope} Log In With Third Party Sso`;

  constructor(public samlLoginUrl: string) {}
}
